/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { DeliveryNoteState, IDeliveryNote } from 'commons/types';
import { ReducerKeys } from 'redux-stores/enums/reducerKey.enum';

const initialState: DeliveryNoteState = {
  deliveryNotes: [],
  totalDeliveryNotes: 0,
  selectedDeliveryNote: null,
  priorityList: [],
};

const deliveryNoteSlice = createSlice({
  name: ReducerKeys.DeliveryNote,
  initialState,
  reducers: {
    setDeliveryNotes(
      state: DeliveryNoteState,
      action: { type: string; payload: IDeliveryNote[] },
    ) {
      state.deliveryNotes = action.payload;
    },
    setTotalDeliveryNotes(
      state: DeliveryNoteState,
      action: { type: string; payload: number },
    ) {
      state.totalDeliveryNotes = action.payload;
    },
    setSelectedDeliveryNote(
      state: DeliveryNoteState,
      action: { type: string; payload: IDeliveryNote | null },
    ) {
      state.selectedDeliveryNote = action.payload;
    },
    setPriorityList(
      state: DeliveryNoteState,
      action: { type: string; payload: string[] },
    ) {
      state.priorityList = action.payload;
    },
    resetDeliveryNoteState(state: DeliveryNoteState) {
      state.deliveryNotes = initialState.deliveryNotes;
      state.selectedDeliveryNote = initialState.selectedDeliveryNote;
    },
  },
});

export const {
  setDeliveryNotes,
  setTotalDeliveryNotes,
  setSelectedDeliveryNote,
  setPriorityList,
  resetDeliveryNoteState,
} = deliveryNoteSlice.actions;

export default deliveryNoteSlice.reducer;
